/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesCancellationComponent} from './part-number-changes-cancellation.component';
import {PipesModule} from '../../shared/pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        PipesModule
    ],
    declarations: [PartNumberChangesCancellationComponent],
    exports: [PartNumberChangesCancellationComponent]
})
export class PartNumberChangesCancellationModule {
}
